



































































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import {
  PORTAL_OFFICE_REVIEW_IS_OPEN,
  PORTAL_OFFICE_REVIEW_APPROVAL_STATUS,
  PORTAL_OFFICE_REVIEW_ASPECT_TYPE_LABEL,
} from "@/consts/portal";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  /** 初回ロード完了フラグ */
  private initLoadingDone = false;
  private showSaveCompleteBar = false;

  private item = null;
  private approvalStatus = null;

  private PORTAL_OFFICE_REVIEW_IS_OPEN = PORTAL_OFFICE_REVIEW_IS_OPEN;
  private PORTAL_OFFICE_REVIEW_APPROVAL_STATUS =
    PORTAL_OFFICE_REVIEW_APPROVAL_STATUS;
  private PORTAL_OFFICE_REVIEW_ASPECT_TYPE_LABEL =
    PORTAL_OFFICE_REVIEW_ASPECT_TYPE_LABEL;

  public async created() {
    await this.fetchItem(Number(this.$route.params.id));
    this.initLoadingDone = true;
  }

  /** 情報取得 */
  private async fetchItem(id: number) {
    return new Promise((resolve) => {
      this.postJsonCheck(
        window.base_url + "/api/admin/portal_office_review/get",
        { portal_office_review_id: id },
        (res) => {
          this.item = res.data.review;
          this.approvalStatus = res.data.review.approval_status;
          resolve(0);
        }
      );
    });
  }

  private async updateApprovalStatus() {
    if (!(await this.$openConfirm("承認ステータスを更新しますか？"))) {
      return;
    }
    const id = Number(this.$route.params.id);
    this.postJsonCheck(
      window.base_url +
        "/api/admin/portal_office_review/update_approval_status",
      {
        portal_office_review_id: id,
        approval_status: Number(this.approvalStatus),
      },
      () => {
        this.fetchItem(id).then(() => {
          this.showSaveCompleteBar = true;
        });
      }
    );
  }
}
